/**
 * Helpers to load existing application-form records (State Mandate, Welcome Letter, etc.)
 * from mixed API response shapes (single entity vs list).
 */

export const pickRecordFromListResult = (result, userId) => {
  if (!result) return null;
  if (result.compliance) return result.compliance;
  if (result.welcomeLetter) return result.welcomeLetter;
  if (result.policy) return result.policy;

  const lists = [
    result.compliances,
    result.welcomeLetters,
    result.items,
    Array.isArray(result) ? result : null,
  ].filter(Array.isArray);

  for (const list of lists) {
    if (list.length === 0) continue;
    if (userId != null) {
      const match = list.find(
        (item) => Number(item.userId) === Number(userId),
      );
      if (match) return match;
    }
    return list[0];
  }

  if (result.id) return result;

  return null;
};

export const parseRecordId = (...candidates) => {
  for (const value of candidates) {
    if (value == null || value === "") continue;
    const parsed = Number(value);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }
  return null;
};
